import isEmpty from 'lodash/isEmpty';
import type { StoreActionApi } from 'react-sweet-state';
import type { State } from '../../../../common/types';
import { setFilters } from '../set-filters';

export const setFilter =
	(filterKey: string) =>
	(newFilterValue: string[] | null) =>
	({ getState, dispatch }: StoreActionApi<State>) => {
		const state = getState();
		const filters = { ...state.filters };
		if (isEmpty(newFilterValue)) {
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
			delete filters[filterKey];
		} else {
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ TEXT?: string | undefined; ASSIGNEE?: string[] | undefined; LABEL?: string[] | undefined; ISSUE_PARENT?: string[] | undefined; ISSUE_TYPE?: string[] | undefined; VERSION?: string[] | undefined; CUSTOM_FILTER?: string[] | undefined; }'.
			filters[filterKey] = newFilterValue;
		}
		dispatch(setFilters(filters));
	};
